import TinySegmenter from '../../utils/tinySegmenter';

const japaneseStopwords: Set<string> = new Set([
  'の',
  'に',
  'は',
  'を',
  'た',
  'が',
  'で',
  'て',
  'と',
  'し',
  'れ',
  'さ',
  'ある',
  'いる',
  'も',
  'する',
  'から',
  'な',
  'こと',
  'として',
  'い',
  'や',
  'など',
  'なっ',
  'よう',
  'それ',
  'これ',
  'あれ',
  'ため',
  'その',
  'この',
  'また',
  'そして',
  'です',
  'ます',
  'ん',
  'へ',
  'まで',
  'より',
  '一',
]);

interface WordFrequency {
  text: string;
  size: number;
}

const segmenter = new TinySegmenter();

export const getWordFrequencies = (
  content: string,
  blockItems?: Set<string>
): WordFrequency[] => {
  const cleanedContent = content
    .replace(/\n\n\d+/g, '') // Remove numbered lines
    .replace(/\n/g, ' ') // Replace newlines with spaces
    .replace(/[,.!?:;"()「」『』\-*、。　\[\]\{\}\\_\\\d]+/g, ' ') // Remove punctuation, brackets, numbers
    .replace(/\s+/g, ' ') // Normalize spaces
    .trim();

  const tokens = segmenter.segment(cleanedContent);

  const filteredTokens = tokens
    .map((word: string) => word.trim())
    .filter((word: string) => {
      if (!word || word.trim() === '') return false;

      if (japaneseStopwords.has(word)) return false;

      if (blockItems) {
        if (blockItems.has(word)) return false;
      }

      if (/^\d+$/.test(word)) return false;

      if (word.includes('\\')) return false;

      if (/^[・.,!?:;\-_=+@#$%^&*()\[\]{}<>|~]+$/.test(word)) return false;

      if (
        word.length === 1 &&
        !/[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/.test(
          word
        )
      )
        return false;

      return true;
    });

  const wordCounts: Record<string, number> = {};
  filteredTokens.forEach((word: string) => {
    wordCounts[word] = (wordCounts[word] || 0) + 1;
  });

  return Object.entries(wordCounts)
    .map(([text, size]: [string, number]): WordFrequency => ({ text, size }))
    .sort((a: WordFrequency, b: WordFrequency) => b.size - a.size);
};

export const createBlockedItemsSet = (blockedString: string): Set<string> => {
  const items = blockedString.split('\n').filter((part) => part);
  return new Set(items);
};

export default getWordFrequencies;

export const defaultColors = () => {
  return [
    '#3E4A89',
    '#E2E857',
    '#481567',
    '#4B528F',
    '#7694AF',
    '#83D381',
    '#24888D',
    '#745892',
  ];
};
